// Main.js
import React from 'react';
import '../styles/Main.css';
import About from './About';
import Project from './Project';
//import Team from './Team';
//import Contact from './Contact';

function Main() {
  return (
    <main className="App-main">
      <About />
      <Project />
    </main>
  );
}

export default Main;
